import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/shared/auth/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthenticationResult } from '@app/shared/interfaces/user-response.interface';
import { MESSAGES } from '@app/shared/utils/messages';

@Component({
  selector: 'app-saml-callback',
  templateUrl: './saml-callback.component.html',
  styleUrls: ['./saml-callback.component.scss'],
  standalone: true,
})
export class SamlCallbackComponent implements OnInit {
  errorMessage: string = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    console.log('SAML callback');
    this.route.queryParams.pipe(filter((params: Params) => params.code)).subscribe({
      next: (params: Params) => {
        this.authService.clear();
        this.authService.samlAuth(params.code).subscribe({
          next: (res: AuthenticationResult) => {
            if (res) {
              this.authService.responseLoginSaml(res);
              this.redirectUserToProfileSelectionOrHome();
            }
          },
          error: () => {
            this.errorMessage = MESSAGES.CONNEXION_ERROR;
          },
        });
      },
    });
  }

  redirectUserToProfileSelectionOrHome(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/home']);
    } else {
      this.authService.emptySession();
      this.errorMessage = MESSAGES.CONNEXION_ERROR;
    }
  }
}
